module.exports = __webpack_public_path__ + "static/media/aside_thongtinmuasamcong.b2187a69.jpg";